// @flow

import React, { type Node, useState } from 'react';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { IfFeature } from '@tectonics/prs/feature';

import { useSendVoucherGenerateEvent } from '@tectonics/analytics';
import { useEventBusListener } from '@tectonics/public-event-bus';
import { Separator } from '../../../../../atoms';
import { HelpCenterInfo } from './help-center-info';
import { CashTitle } from './cash-title';

import { MailWarning } from './mail-warning';

import {
  VoucherTicketAmount,
} from '../../commons/voucher';

import {
  DisplayEfectyDueDate,
  DisplayEfectyVoucherCode,
  DisplayEfectyInstructions,
} from './efecty';

export function EfectyPageContent(): Node {
  const features = useAllFeatures();

  const [isReady, setReady] = useState<bool>(false);

  useEventBusListener('bromelia:step:thank_you', () => {
    setReady(true);
  });

  useSendVoucherGenerateEvent(isReady);

  return (
    <div data-test-id="page-pending-payment">

      <CashTitle />

      <IfFeature allFeatures={features} wanted="display_cash_email_warning">
        <MailWarning />
      </IfFeature>

      <div style={paymentInfoWrapperStyle}>
        <IfFeature allFeatures={features} wanted="display_cash_total_value">
          <VoucherTicketAmount />
        </IfFeature>
        <IfFeature allFeatures={features} wanted="display_efecty_due_date">
          <DisplayEfectyDueDate />
        </IfFeature>
      </div>

      <Separator direction="vertical" pattern="dotted" size={5} />

      <IfFeature allFeatures={features} wanted="display_efecty_voucher_code">
        <DisplayEfectyVoucherCode />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="display_efecty_instructions">
        <Separator direction="vertical" pattern="dotted" size={5} />
        <DisplayEfectyInstructions />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="display_cash_help_center_info">
        <HelpCenterInfo />
      </IfFeature>
    </div>
  );
}

const paymentInfoWrapperStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  padding: '15px',
  borderRadius: '5px',
  background: 'rgb(248, 248, 249)',
};
